module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/deskoffice/desk.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/deskoffice/desk.png
// module id = 557
// module chunks = 0